import FictivSymbol from '~/lib/FictivSymbol'

export const SET_QUOTE_DETAILS_PAGE_LOADING = FictivSymbol(
    'SET_QUOTE_DETAILS_PAGE_LOADING',
)
export const CONFIGURATION_TAB_QUERY_SUCCESS = FictivSymbol(
    'CONFIGURATION_TAB_QUERY_SUCCESS',
)

export const CONFIGURATION_TAB_QUERY_FAILURE = FictivSymbol(
    'CONFIGURATION_TAB_QUERY_FAILURE',
)
export const CORE_QUOTE_DETAILS_QUERY_SUCCESS = FictivSymbol(
    'CORE_QUOTE_DETAILS_QUERY_SUCCESS',
)

export const CORE_QUOTE_DETAILS_QUERY_RESET = FictivSymbol(
    'CORE_QUOTE_DETAILS_QUERY_RESET',
)

export const CORE_QUOTE_DETAILS_QUERY_FAILURE = FictivSymbol(
    'CORE_QUOTE_DETAILS_QUERY_FAILURE',
)

export const LEGACY_QUOTE_DETAILS_QUERY_LOADING = FictivSymbol(
    'LEGACY_QUOTE_DETAILS_QUERY_LOADING',
)

export const LEGACY_QUOTE_DETAILS_QUERY_FAILURE = FictivSymbol(
    'LEGACY_QUOTE_DETAILS_QUERY_FAILURE',
)
export const IM_FEEDBACK_ADDREQ_UNCONFIGUREDCONFIGMODAL_TABS_QUERY_SUCCESS =
    FictivSymbol(
        'IM_FEEDBACK_ADDREQ_UNCONFIGUREDCONFIGMODAL_TABS_QUERY_SUCCESS',
    )

export const IM_FEEDBACK_ADDREQ_UNCONFIGUREDCONFIGMODAL_TABS_QUERY_FAILURE =
    FictivSymbol(
        'IM_FEEDBACK_ADDREQ_UNCONFIGUREDCONFIGMODAL_TABS_QUERY_FAILURE',
    )
export const CONFIG_MODAL_THREAD_FEEDBACK_ADD_REQ_QUERY_SUCCESS = FictivSymbol(
    'CONFIG_MODAL_THREAD_FEEDBACK_ADD_REQ_QUERY_SUCCESS',
)

export const CONFIG_MODAL_THREAD_FEEDBACK_ADD_REQ_QUERY_FAILURE = FictivSymbol(
    'CONFIG_MODAL_THREAD_FEEDBACK_ADD_REQ_QUERY_FAILURE',
)

export const DRAWING_ANALYSIS_TAB_QUERY_SUCCESS = FictivSymbol(
    'DRAWING_ANALYSIS_TAB_QUERY_SUCCESS',
)

export const DRAWING_ANALYSIS_TAB_QUERY_FAILURE = FictivSymbol(
    'DRAWING_ANALYSIS_TAB_QUERY_FAILURE',
)
